import { actionTypes } from '../constants'

const initialState = {
  isOpen: {
    architects: false,
    arup_services: false,
    country: false,
    hall_uses: false,
    in_outdoor: false,
    project_types: false,
    seat_count: false,
    year: false,
  },
  searches: {
    architects: '',
    country: '',
  }
}

const filter = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.CLEAR_ALL_WAS_CLICKED:
      return {
        ...state,
        isOpen: {
          architects: false,
          arup_services: false,
          country: false,
          hall_uses: false,
          in_outdoor: false,
          project_types: false,
          seat_count: false,
          year: false,
        }
      }

    case actionTypes.DOCUMENT_WAS_CLICKED_OUTSIDE_OF_OPEN_FILTER:
      return {
        ...state,
        isOpen: {
          architects: false,
          arup_services: false,
          country: false,
          hall_uses: false,
          in_outdoor: false,
          project_types: false,
          seat_count: false,
          year: false,
        }
      }

    case actionTypes.FILTER_CONTROL_WAS_CLICKED:
      return {
        ...state,
        isOpen: {
          ...state.isOpen,
          [action.payload.esKey]: !state.isOpen[action.payload.esKey],
        },
        searches: {
          ...state.searches,
          [action.payload.esKey]: '',
        }
      }

    case actionTypes.FILTER_SEARCH_WAS_CHANGED:
      return {
        ...state,
        searches: {
          ...state.searches,
          [action.payload.esKey]: action.payload.search,
        },
      }

    default:
      return state
  }
}

export default filter
